import http from './http'

export const SITE_ARTICLE_PAGE_SIZE = 10

export function fetchSitePages() {
  return http.get('/saas_api.php', {
    params: { action: 'site_pages' }
  }).then(result => {
    if (result.status !== 1 || !result.data) {
      return { enabled: false, pages: [] }
    }
    return result.data
  })
}

export function fetchSitePage(key) {
  return http.get('/saas_api.php', {
    params: { action: 'site_page', key }
  })
}

export function fetchSiteArticles(page = 1, pageSize = SITE_ARTICLE_PAGE_SIZE) {
  return http.get('/saas_api.php', {
    params: {
      action: 'site_articles',
      page,
      page_size: pageSize
    }
  }).then(result => {
    if (result.status !== 1 || !result.data) {
      return {
        enabled: false,
        list: [],
        total: 0,
        page: 1,
        page_size: pageSize,
        total_pages: 0
      }
    }
    return result.data
  })
}

export function fetchSiteArticle(id) {
  return http.get('/saas_api.php', {
    params: { action: 'site_article', id }
  })
}
